// Formats every current browser renders in an <img>. RAW (NEF, ARW, CR2, …), HEIC and TIFF are
// not among them, so the viewer never downloads those originals to display them.
const BROWSER_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/avif', 'image/bmp'];
const BROWSER_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'avif', 'bmp'];

/** Whether a browser can show the file itself (as opposed to only Drive's thumbnail of it). */
export function canDisplayInBrowser(file: { name: string; mimeType?: string }): boolean {
    if (file.mimeType && file.mimeType.startsWith('image/')) {
        return BROWSER_IMAGE_TYPES.includes(file.mimeType);
    }
    // Drive reports some uploads without a specific type; the extension is all we have then.
    const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
    return BROWSER_IMAGE_EXTENSIONS.includes(extension);
}

export type ViewerSource = 'original' | 'preview' | 'unavailable';

export interface ViewerSourceInput {
    /** The original is a format the browser can show. */
    displayable: boolean;
    /** The user turned the "Eredeti" switch on. */
    showOriginal: boolean;
    /** The original is already downloaded (e.g. prefetched, or loaded for EXIF). */
    originalCached: boolean;
    /** Drive offers a thumbnail to enlarge. */
    hasPreview: boolean;
    /** That thumbnail failed to load. */
    previewFailed: boolean;
}

/** What the viewer displays: the original when asked for or already at hand, else Drive's large preview. */
export function chooseViewerSource(input: ViewerSourceInput): ViewerSource {
    if (input.displayable && (input.showOriginal || input.originalCached)) return 'original';
    if (input.hasPreview && !input.previewFailed) return 'preview';
    return input.displayable ? 'original' : 'unavailable';
}
